const Permission =
{
    DASHBOARD: "dashboard",
    STUDENT: "student",
    ADMISSION_REGISTER: "admission_register",
    ADMISSION: "admission",
    SETTING: "setting",
    REPORT: "report",
    APPLICANT: "applicant",
    ACCOUNTANT: "accountant",
    MARKETING: "marketing",
    STUDENTAFFAIRS: "studentaffairs",
    SCHOLARSHIP: "scholarship",

    ADMISSION_CREATE: "CREATE",
    ADMISSION_VIEW: "VIEW",
    ADMISSION_EDIT_GRADUATION: "EDIT_GRADUATION",

    REPORT_VIEW: "REPORT_VIEW",

    DASHBOARD_VIEW: "VIEW",

    STUDENT_VIEW: "VIEW",
    STUDENT_CREATE: "CREATE",
    STUDENT_EDIT: "EDIT",
    STUDENT_EXPORT: "EXPORT",
    STUDENT_IMPORT: "IMPORT",
    STUDENT_VIEW_DETAIL: "VIEW_DETAIL",
    STUDENT_DELETE: "DELETE",
    STUDENT_VIEW_DELETE: "VIEW_DELETE",
    STUDENT_RESTORE: "RESTORE",
    STUDENT_DESTROY: "DESTROY",
    STUDENT_EDIT_STATUS: "EDIT_STATUS",
    STUDENT_EDIT_GRADUATION: "EDIT_GRADUATION",
    // Trang "Đồng bộ Bộ GD&ĐT" (/dongbobgd): đối soát + ÁP DỤNG nguyện vọng Bộ, điền điểm, import
    // điểm Bộ — toàn thao tác ghi HÀNG LOẠT nên tách quyền riêng, không dùng ké IMPORT như trước.
    // Backend gác thật bằng requirePermission('student','BGD_SYNC'); migration 20260810110000 cấp
    // sẵn role 1+3 và mọi role đang có student.IMPORT (giữ nguyên quyền đang dùng).
    // BGD_SYNC = mở trang + thao tác CHỈ ĐỌC; BGD_APPLY = thao tác GHI hàng loạt (Áp dụng NV,
    // Chạy điền điểm, Ghi điểm import). Tách 2 mức để cấp được vai trò rà-soát-không-được-ghi.
    STUDENT_BGD_SYNC: "BGD_SYNC",
    STUDENT_BGD_APPLY: "BGD_APPLY",
    // Tìm kiếm/xem danh sách KHÔNG giới hạn phụ trách (Search toàn cục + DS ứng viên/hồ sơ).
    // Migration BE 20260717100000 cấp sẵn role 1+3; role khác cấp qua trang Phân quyền.
    STUDENT_SEARCH_ALL: "SEARCH_ALL",

    ADMISSION_REGISTER_VIEW: "VIEW",
    ADMISSION_REGISTER_CREATE: "CREATE",
    ADMISSION_REGISTER_EDIT: "EDIT",
    ADMISSION_REGISTER_EXPORT: "EXPORT",
    ADMISSION_REGISTER_IMPORT: "IMPORT",
    ADMISSION_REGISTER_VIEW_DETAIL: "VIEW_DETAIL",
    ADMISSION_REGISTER_DELETE: "DELETE",
    ADMISSION_REGISTER_VIEW_DELETE: "VIEW_DELETE",
    ADMISSION_REGISTER_RESTORE: "RESTORE",
    ADMISSION_REGISTER_DESTROY: "DESTROY",
    ADMISSION_REGISTER_EDIT_STATUS: "EDIT_STATUS",
    ADMISSION_REGISTER_ATTACHMENT: "ATTACHMENT",
    ADMISSION_REGISTER_PRINT: "PRINT",
    ADMISSION_REGISTER_EMAIL: "EMAIL",
    ADMISSION_REGISTER_DOWNLOAD: "DOWNLOAD",

    APPLICANT_VIEW: "VIEW",
    APPLICANT_EDIT: "EDIT",
    APPLICANT_EXPORT: "EXPORT",
    APPLICANT_IMPORT: "IMPORT",
    APPLICANT_PRINT: "PRINT",
    APPLICANT_VIEW_DETAIL: "VIEW_DETAIL",
    // "Xuất Excel cho P.TCKT" ở Danh sách nhập học — bộ cột riêng của Phòng Tài chính - Kế toán
    // (bỏ SĐT/Email UMT, thêm địa chỉ cư trú). Quyền RIÊNG, cấp độc lập với EXPORT thường.
    // Migration BE 20260810100000 cấp sẵn cho superadmin(1)+admin(3); role khác cấp qua trang Phân quyền.
    APPLICANT_EXPORT_TCKT: "EXPORT_TCKT",

    ACCOUNTANT_VIEW: "VIEW",
    ACCOUNTANT_EXPORT: "EXPORT",
    ACCOUNTANT_IMPORT: "IMPORT",
    ACCOUNTANT_VIEW_DETAIL: "VIEW_DETAIL",
    ACCOUNTANT_PRINT: "PRINT",
    SETTING_VIEW: "VIEW",
    SETTING_CREATE: "CREATE",
    SETTING_EDIT: "EDIT",

    MARKETING_VIEW: "VIEW",
    STUDENTAFFAIRS_VIEW: "VIEW",

    SCHOLARSHIP_VIEW: "VIEW",
    SCHOLARSHIP_VIEW_DETAIL: "VIEW_DETAIL",
    SCHOLARSHIP_EDIT: "EDIT",
    SCHOLARSHIP_CREATE: "CREATE",
    SCHOLARSHIP_PRINT: "PRINT",
    SCHOLARSHIP_EXPORT: "EXPORT",
    SCHOLARSHIP_IMPORT: "IMPORT",
    // Phê duyệt/Từ chối cấp học bổng (thay hardcode v-role=[1,3] cũ; migration BE 20260716100000
    // đã cấp sẵn cho superadmin+admin, role khác cấp qua trang Phân quyền)
    SCHOLARSHIP_APPROVE: "APPROVE",
    // Tool "Rà soát ưu đãi cấp-trước" ở menu Công cụ (quyền RIÊNG, cấp độc lập với xem HB).
    // Migration BE 20260728100000 cấp sẵn cho superadmin(1)+admin(3); role khác cấp qua trang Phân quyền.
    SCHOLARSHIP_REVIEW_ADVANCE: "REVIEW_ADVANCE",

}

export default Permission;
